import { Rectangle } from "lib/math";
import { MapEntity } from "../../../../lib/gamemap/MapEntity";
import { Transportation } from "../../../../lib/runescape/transportation";
import { FloorLevels } from "../../../../lib/gamemap/ZoomLevels";
import { floor_t } from "../../../../lib/runescape/coordinates";
import { TileArea } from "../../../../lib/runescape/coordinates/TileArea";
import { C } from "../../../../lib/ui/constructors";
import { CursorType } from "../../../../lib/runescape/CursorType";
import * as leaflet from "leaflet";
import { ShortcutViewLayer } from "../../shortcut_editing/ShortcutView";
import Properties from "../../widgets/Properties";
var entity = C.entity;
var COLORS = ShortcutViewLayer.COLORS;
var TeleportGroup = Transportation.TeleportGroup;
var vbox = C.vbox;
import { LeafletUtils } from "../../../../lib/gamemap/LeafletUtils";
import { LeafletPolygonConstructors } from "../../../../lib/gamemap/LeafletPolygonConstructors";
var areaPolygon = LeafletPolygonConstructors.areaPolygon;
export class TeleportAccessEntity extends MapEntity {
    bounds() {
        return TileArea.toRect(this.access.clickable_area);
    }
    async render_implementation(options) {
        const access = this.access;
        const scale = (options.highlight ? 1.5 : this.zoom_sensitivity_layers.get(options.zoom_group_index).value.scale);
        const marker = leaflet.marker(LeafletUtils.latLongFromVector2(Rectangle.center(TileArea.toRect(access.clickable_area), true)), {
            icon: leaflet.icon({
                iconUrl: CursorType.meta(access.cursor ?? "generic").icon_url,
                iconSize: CursorType.iconSize(scale),
                iconAnchor: CursorType.iconAnchor(scale, true),
            }),
            riseOnHover: true,
            interactive: true
        }).addTo(this);
        if (options.highlight) {
            areaPolygon(TeleportGroup.TeleportAccess.interactiveArea(access)).setStyle({
                color: COLORS.interactive_area,
                fillColor: COLORS.interactive_area,
                interactive: true,
                fillOpacity: 0.1,
                weight: 2
            }).addTo(this);
        }
        return marker.getElement();
    }
    constructor(teleport, access) {
        super();
        this.teleport = teleport;
        this.access = access;
        this.zoom_sensitivity_layers = MapEntity.default_zoom_scale_layers;
        this.floor_sensitivity_layers = undefined;
        this.zoom_sensitivity_layers = MapEntity.default_local_zoom_scale_layers;
        this.floor_sensitivity_layers = new FloorLevels([
            { floors: [access.clickable_area.origin.level], value: { correct_level: true } },
            { floors: floor_t.all, hidden_here: true, value: { correct_level: false } },
        ]);
        this.setTooltip(() => {
            let props = new Properties();
            const teleport = this.teleport;
            const access = this.access;
            props.header(c().append(`Access to ${teleport.name} via `, entity(access.name)));
            props.named("Targets", vbox(...teleport.spots.map(spot => {
                return c().text(spot.name);
            })));
            return props;
        });
    }
    async contextMenu(event) {
        const teleport = this.teleport;
        const access = this.access;
        event.addForEntity({
            type: "submenu",
            text: "Move map to",
            children: teleport.spots.map(spot => {
                const s = new TeleportGroup.Spot(teleport, spot, access);
                return {
                    type: "basic",
                    icon: `assets/icons/teleports/${s.image().url}`,
                    text: s.code() ? `${spot.code}: ${spot.name}` : spot.name,
                    handler: () => {
                        this.parent?.getMap()?.fitView(TileArea.toRect(spot.target));
                    }
                };
            })
        });
        return {
            type: "submenu",
            icon: CursorType.meta(access.cursor ?? "generic").icon_url,
            text: () => entity(access.name),
            children: []
        };
    }
}
